var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXeuWhiteRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5C20 19.1944 16.1944 23 11.5 23C6.80558 23 3 19.1944 3 14.5C3 9.80558 6.80558 6 11.5 6H12.5",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.20711C12 0.761654 12.5386 0.538571 12.8536 0.853553L17.6464 5.64645C17.8417 5.84171 17.8417 6.15829 17.6464 6.35355L12.8536 11.1464C12.5386 11.4614 12 11.2383 12 10.7929V1.20711Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXeuWhiteRunning);
export default __webpack_public_path__ + "static/media/xeu-white-running.ddd10373852ae2a6f411f92e7694aaf2.svg";
export { ForwardRef as ReactComponent };